import { type ReactNode } from "react";
import ProfesseurHeader from "./headers/ProfesseurHeader";
import DashboardFooter from "./DashboardFooter";

// Composant de mise en page spécifique pour le dashboard Professeur
function ProfesseurDashboardLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col min-h-screen">
      <ProfesseurHeader />
      <main className="flex-grow">{children}</main>
      <DashboardFooter />
    </div>
  );
}

export default ProfesseurDashboardLayout;
